import React, {useEffect, useState} from "react";
import Loading from "../Loading/Loading";
import useCreditService from "../../api/services/useCreditService";
import useProfileBoostService from "../../api/services/useProfileBoostService";
import Button from "../Button/Button";
import useFunction from "../../hooks/useFunction";
import {useNavigate} from "react-router-dom";
import cloneDeep from 'lodash/cloneDeep';

const PayWithCredits = ({amount, profileBoostId, form}) => {
  const [credits, setCredits] = useState(0); // in centen
  const [ownedCredits, setOwnedCredits] = useState(0); // in centen
  const [isLoading, setIsLoading] = useState(true);
  const {userShow} = useCreditService();
  const {userPay} = useProfileBoostService();
  const {formatEuro} = useFunction();
  const totalInCents = Math.round(amount * 100);
  const restInCents = Math.max(totalInCents - credits, 0);
  const navigate = useNavigate()

  useEffect(() => {
    setIsLoading(true);
    userShow(
      (userCredits) => {
        setOwnedCredits(userCredits);
        setCredits(Math.min(userCredits, Math.round(amount * 100))); // fix
        setIsLoading(false);
      },
      () => setIsLoading(false)
    );
  }, []);

  const handleInputChange = (e) => {
    const val = parseInt(e.target.value, 10) || 0;
    setCredits(Math.min(val, ownedCredits));
  };

  const handleSubmit = () => {
    setIsLoading(true);
    userPay((data) => {
        setIsLoading(false)
        if ('payment_url' in data && data.payment_url) {
          window.location.href = data.payment_url;
        } else {
          form.formData.model = data.profile_boost
          form.setOriginalFormDataModel(cloneDeep(data.profile_boost))
          form.save(false)
          navigate('/wizard/boost/check_payment/' + profileBoostId)
        }
      },
      () => {
      },
      profileBoostId,
      credits
    )
  }

  return (
    <div className="component-pay-with-credits">
      {isLoading ? (
        <Loading/>
      ) : (
        <>
          <p><strong>Je hebt {ownedCredits} credits</strong></p>
          {ownedCredits > 0 &&
            <label>
              Gebruik credits:
              <input
                className="credits-input"
                type="number"
                min="0"
                max={Math.min(ownedCredits, Math.round(amount * 100))}
                value={credits}
                onChange={handleInputChange}
              />
            </label>
          }
          <p>
            Totaal: {formatEuro(amount)}<br/>
            Betaal met credits: {credits}<br/>
            Te voldoen via iDeal: {formatEuro(restInCents / 100)}
          </p>
          <Button
            label={restInCents === 0 ? "Betaal met credits" : "Betaal met iDeal"}
            onClick={handleSubmit}
            debounce={3000}
          />
        </>
      )}
    </div>
  );
};

export default PayWithCredits;
